import { AxiosResponse } from "axios";
import { get } from "./api";

export interface BinCheckResponse {
  success: boolean;
  signup_url: string;
}

export const getCapitalOneBinCheck = (bin: string): Promise<AxiosResponse<BinCheckResponse>> => {
  return get(`/api/v2/subscriptions/capitalone_bin_check?bin=${bin}`);
};
